var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeasuringTape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ezkKiYncw3S1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "16afafaa59f142b48de2a775d8cc772d",
    "export-id": "2535907902044591a348abe35f86636c",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "ezkKiYncw3S2",
    width: 59.7,
    height: 3,
    rx: 0,
    ry: 0,
    transform: "translate(34.244854 336.812917)",
    fill: "#ffe0a4",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "ezkKiYncw3S3",
    width: 4.061027,
    height: 4.827894,
    rx: 0,
    ry: 0,
    transform: "translate(93.943146 336.812917)",
    fill: "#303030",
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.320697 0 0 0.320697-.083932 258.30962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ezkKiYncw3S5",
    d: "M265.661,153.519l14.499,3.345c10.423,2.405,13.036,23.419,13.036,23.419l-20.021,58.83-7.514-85.594Z",
    transform: "translate(0-.997346)",
    fill: "#262728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.963,259.844h-251.4693c-13.9352,0-25.231981-11.297-25.231981-25.233v-118.788C0.261719,51.9407,52.0489,0.154563,115.932,0.154563v0c84.24,0,153.439,66.532237,156.747,150.707437l4.284,108.982Z",
    fill: "#fcbc3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.261719,173.917v60.694c0,25.232999,11.296781,25.233,25.231981,25.233h60.6955c-47.4566,0-85.927481-38.472-85.927481-85.927Z",
    fill: "#f5a028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.181,219.188h-83.411c-43.7326,0-79.185-35.453-79.185-79.187v-19.735c0-43.8782,35.5703-79.4503,79.449-79.4503v0c57.861,0,105.39,45.6989,107.662,103.5163l1.865,47.419c.587,14.976-11.394,27.437-26.38,27.437Z",
    fill: "#262728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.697,131.219c0,26.796-21.72,48.515-48.514,48.515s-48.5141-21.719-48.5141-48.515c0-26.793,21.7201-48.5121,48.5141-48.5121s48.514,21.7191,48.514,48.5121Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.99,131.22c0,12.045-9.763,21.807-21.807,21.807s-21.807-9.762-21.807-21.807c0-12.042,9.763-21.807,21.807-21.807s21.807,9.765,21.807,21.807Z",
    fill: "#f5a028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.632,1.78759C41.9412,10.9797,0.261719,58.5209,0.261719,115.824v44.703C6.95629,157.342,11.2211,150.589,11.2211,143.176v-26.231c0-45.743,28.8425-84.7649,69.3331-99.8388C87.7709,14.4198,93.5365,8.83889,96.632,1.78759Z",
    fill: "#262728"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.99994,
    height: 1.99999,
    rx: 0,
    ry: 0,
    transform: "matrix(1.000006 0 0 1.000005 260.661 257.844)",
    fill: "#fcbc3d",
    strokeWidth: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasuringTape);
export default __webpack_public_path__ + "static/media/MeasuringTape.0c1fe90a67eff09379681df4a60fcbb5.svg";
export { ForwardRef as ReactComponent };